"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPopoverIcon = void 0;
var _PopoverIcon = require("./PopoverIcon");
// TODO: in v9, move styled() from PopoverIcon.jsx to here
var StyledPopoverIcon = _PopoverIcon.PopoverIcon;
exports.StyledPopoverIcon = StyledPopoverIcon;